// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db, auth, functions  } from '@/shared/firebase/firebase-init';
import * as firebase from 'firebase';
import userService from '@/user/user-service';
import managerService from '@/entities/manager/manager-service';
import managerModel from '@/entities/manager/manager-model';

import _ from 'underscore'


export default {
  onAuthStateChanged(callbackSuccess, callbackError) {
    firebase
      .auth()
      .onAuthStateChanged(callbackSuccess, callbackError);
  },

  sendEmailVerification(firebaseUser) {
    return firebaseUser.sendEmailVerification();
  },

  sendPasswordResetEmail(email) {
    return Promise.resolve().then(() =>
      firebase.auth().sendPasswordResetEmail(email),
    );
  },

  registerManager(model) {
    return new Promise((resolve, reject) => {
       firebase
          .auth()
          .createUserWithEmailAndPassword(model.email, model.password)
      .then((firebaseUser) => {
        userService.findUserNoVerifiedByEmail(model.email)
        .then((userNoVerified) => {
          console.log("<--- userNoVerified finded");
          console.log(userNoVerified);
          
          console.log("<--- userNoVerified firebase");
          console.log(firebaseUser);
          
          if (userNoVerified.roles === undefined) {
            reject("Link invalid")
          }

          const modelUserToSave = {
            id: firebaseUser.user.uid,
            roles: userNoVerified.roles,
            email: model.email.trim()
          }

          const modelManagertoSave = {
            id: firebaseUser.user.uid,
            email: model.email,
            name: model.name,
            lastName: model.lastName,
            phone: model.phone,
            clubs: userNoVerified.clubs
          }

          const loggerUser = {
            id: firebaseUser.user.uid,
            email: model.email
          }
          
          console.log("<--- userNoVerified modelUserToSave");
          console.log(modelUserToSave);
          console.log("<--- userNoVerified modelManagertoSave");
          console.log(modelManagertoSave);
          
          managerService.save(managerModel.forCreate(modelManagertoSave), loggerUser).then(() => {
            console.log("<--- manager save");

            userService.create(modelUserToSave, loggerUser ).then(() => {
              console.log("<--- user save");
              firebase.auth().currentUser.sendEmailVerification().then(() => {

                  // 5. Eliminamos el usuario de los usuarios no verificados
                  db.ref('userNoVerified').child(userNoVerified.id).set(null)
                  
                  // 6. Actualizamos el (statusManager=verified) de los clubs del usuario
                  _.each( userNoVerified.clubs, (value, key, obj) => {
                    console.log("key club");
                    console.log(key);
                    
                    db.ref('clubs').child(key).child('statusManager').set("verified")
                    db.ref('clubs').child(key).child('manager').set(managerModel.forSimple(modelManagertoSave))
                  })

                  resolve()
                }).catch((error) => {
                  reject(error)
                })
            }).catch((error) => {
              reject(error)
            })
          }).catch((error) => {
            reject(error)
          })
        }).catch((error) => {
          reject(error)
        })
      }).catch((error) => {
        reject(error)
      });
    });
  },
  register(email, password) {
    return new Promise((resolve, reject) => {
       firebase
          .auth()
          .createUserWithEmailAndPassword(email, password)
      .then((firebaseUser) => {
        userService.findUserNoVerifiedByEmail(email)
        .then((user) => {
          console.log("<--- user finded");
          console.log(user);
          
          console.log("<--- user firebase");
          console.log(firebaseUser);
          
          if (user.roles === undefined) {
            reject("Link invalid")
          }

          const modelToSave = {
            id: firebaseUser.user.uid,
            roles: user.roles,
            email: email
          }

          const loggerUser = {
            id: firebaseUser.user.uid,
            email: email
          }
          
          console.log("<--- user modelToSave");
          console.log(modelToSave);
          
          userService.create(modelToSave, loggerUser ).then(() => {
            console.log("<--- user save");
            firebase.auth().currentUser.sendEmailVerification().then(() => {

                // 5. Eliminamos el usuario de los usuarios no verificados
                db.ref('userNoVerified').child(user.id).set(null)
                // 6. Actualizamos el (statusManager=verified) de los clubs del usuario
                _.each( user.clubs, (value, key, obj) => {
                  console.log("key club");
                  console.log(key);
                  
                  db.ref('clubs').child(key).child('statusManager').set("verified")
                  db.ref('clubs').child(key).child('statusManager').set("verified")
                })

                resolve()
              }).catch((error) => {
                reject(error)
              })
          }).catch((error) => {
            reject(error)
          })
         
        }).catch((error) => {
          reject(error)
        })
      }).catch((error) => {
        reject(error)
      });
    });
  },

  signin(email, password) {
    return Promise.resolve().then(() =>
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
    );
  },

  signout() {
    return firebase.auth().signOut();
  },

  /*
   * The auth token doesn't have the storage metadata
   * used to validate if the user has permission to read or upload files
   * This method reauthenticate with this token.
   */
  // reauthenticateWithStorageToken() {
  //   return firebaseAxios().then((axios) =>
  //     axios
  //       .get(`/users/storageToken`)
  //       .then((response) =>
  //         firebase
  //           .auth()
  //           .signInWithCustomToken(response.data.token),
  //       )
  //       .catch(() =>
  //         Promise.reject(
  //           new Error('Error configuring file storage'),
  //         ),
  //       ),
  //   );
  // },
};



// WEBPACK FOOTER //
// ./src/auth/auth-service.js